/** @jsxRuntime classic */
/** @jsx jsx */
import { gql } from '@apollo/client';
import { P } from '@bottlebooks/gatsby-design-system';
import { Trans } from '@lingui/macro';
import { graphql } from 'gatsby';
import { jsx } from 'theme-ui';
import Section from '../Section/Section';

export default function Vinification({ wine, ...rest }) {
  if (!wine?.vinification) return null;
  return (
    <Section title={<Trans>Vinification</Trans>} {...rest}>
      {wine.vinification.split('\n\n').map((p, index) => (
        <P key={index} variant="large">
          {p}
        </P>
      ))}
    </Section>
  );
}

export const fragment = graphql`
  fragment Vinification on Bottlebooks_Wine {
    vinification
  }
`;

Vinification.fragment = gql`
  fragment Vinification on Wine {
    vinification
  }
`;
